"use client";

import { PersianNum } from "@/src/tools";
import { ProductIdentityProductGetType } from "@/src/types/product";
import { PriceAttribute } from "../../tools";

interface AttributePricesProps {
  data: ProductIdentityProductGetType[];
  checkData: PriceAttribute[];
  prodIID: number;
}

const AttributePrices = ({ data, prodIID }: AttributePricesProps) => {
  const selectedIdentity = data.find(identity => identity.id === prodIID);
  if (!selectedIdentity) return <div>قیمتی یافت نشد</div>;

  const warehouse = selectedIdentity?.Warehouses[0];
  const price = warehouse?.warehouse_price;
  const discount = warehouse?.warehouse_discount;

  const discountPercent = price && discount && price > discount
    ? Math.round(((price - discount) / price) * 100)
    : 0;

  return (
    <div className="p-1">
      {discount === 0 ? (
        <div className="text-slate-800 font-bold">
          <p>{PersianNum(price)}</p>
          <span className="mr-1">تومان</span>
        </div>
      ) : (
        <div className="w-full gap-1">
          <div className="w-full">
            <div className="flex items-center h-12 justify-end text-slate-800">
              {
                warehouse.warehouse_count <= 3 && warehouse.warehouse_count != 0  ?
                  <p className="ml-2 text-xs text-red-600"> {PersianNum(warehouse.warehouse_count)}  عدد در انبار</p>
                  : null

              }
              <div className="flex items-center h-12 justify-end text-slate-800">
                <p className="font-bold text-xl">{PersianNum(discount)}</p>
                <span className="mr-1 text-sm ">تومان</span>
              </div>

            </div>

            <div className="flex items-center  h-8 justify-end  text-slate-500">
              <span className="ml-2 text-red-600 text-xl">{PersianNum(discountPercent)}٪</span>
              <p className="line-through">{PersianNum(price)}</p>
              <span className="mr-1 text-sm">تومان</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};


export default AttributePrices;
